// Ads dashboard trend chart helpers: series colours match the metric tiles (components/ad_dashboard.css) and the
// scrub readout reads "9/21 · 曝光數 120 · 點擊數 8" (CTR with a %).
export const SERIES_COLORS = { impressions: "#f97316", clicks: "#eab308", ctr: "#3b82f6" }

const COUNT = new Intl.NumberFormat("zh-TW")

export function trendReadout({ label, keys, names, series, index }) {
  if (label === undefined) return ""
  const parts = keys.map((key) => {
    const value = series[key]?.[index] ?? 0
    const text = key === "ctr" ? `${Number(value).toFixed(1)}%` : COUNT.format(value)
    return `${names[key] || key} ${text}`
  })
  return [ label, ...parts ].join(" · ")
}
